import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import { StyleClientCarousel } from './ClientCarousel.styled';
import ClientCarouselCard from './ClientCarouselCard';
import { CLIENT_IMAGE, settings } from './ClientCarouselConfig';

/**
 *
 * @returns information of xpressbees clients with a carousel
 * we are importing ClientImages from config file.
 * We have implemented map method for ClientImage array which we are importing from config file,
 * which helps us to not repeat the code.
 *
 */
const ClientCarousel = () => {
  const t = useTranslation();
  return (
    <StyleClientCarousel data-testid='ClientCarousel-container'>
      <h3 className='title'>{t('app.CLIENT_CONTAINER')}</h3>
      <div className='ClientBox'>
        {CLIENT_IMAGE.map((data, index) => {
          return <ClientCarouselCard img={data.img} key={index} />;
        })}
      </div>
    </StyleClientCarousel>
  );
};
export default React.memo(ClientCarousel);
